export type BannerAlignment = 'left' | 'center' | 'right';

export type BannerLine = {
  text: string;
  align: BannerAlignment;
  bold: boolean;
};

/**
 * Small, intentionally safe banner markup:
 * [left], [center], [right] at the start of a line and [b]...[/b] for bold.
 * Unmarked lines remain centred, so existing invitation text keeps working.
 */
export function parseBannerMarkup(copy: string): BannerLine[] {
  return copy.split(/\r?\n/).map((source) => {
    const match = source.match(/^\[(left|center|right)\]/i);
    const align: BannerAlignment = (match?.[1]?.toLowerCase() as BannerAlignment | undefined) ?? 'center';
    const withoutAlignment = source.slice(match?.[0].length ?? 0);
    const bold = /\[b\]/i.test(withoutAlignment);
    const text = withoutAlignment.replace(/\[\/?b\]/gi, '');
    return { text, align, bold };
  });
}
